import Data from '../data/data.json';
import Text from '../data/text.json';
import TextTest from '../data/text-ja.json';

export const JSON_DATA: Record<string, any> = Data;
export const JSON_TEXT: Record<string, any> = {
  en: Text,
  ja: TextTest
};
